//Graphing doesn't always load, (x,y) tracking doesn' work on first load, and app often crashes with tracking 

import React, { Children } from 'react'
import { View, Text, Icon,LoadingIcon } from '../../Components'
import _ from 'lodash'
// import { LineChart} from 'react-native-svg-charts';
import { months, days,ToolTypes, channelColors as colors, Colors, Helpers, Metrics, Fonts,Spacing } from '../../global'
// import {
//     svg,
//     circle,
//     G,
//     Line,
//     rect,
//     Text as text,
// } from 'react-native-svg';
import { THP_CH_ENUM} from '../../Tools/THP'
import { SDP1_CH_ENUM} from '../../Tools/SDP1'
import { ST4C_CH_ENUM } from '../../Tools/ST4C'
import { SA4C_CH_ENUM } from '../../Tools/SA4C'
import { SSS1_CH_ENUM } from '../../Tools/SSS1'
import { SCP1_CH_ENUM } from '../../Tools/SCP1'
import HelperService from '../../Helpers/HelperService'
// import { useSelector } from 'react-redux'
// import { getTimeFormat } from '../../Stores/User/Selectors'
import sliderIcon from '../../Assets/SVG/Slider.svg'
import leftIcon from '../../Assets/SVG/ArrowBackSmallG.svg'
import rightIcon from '../../Assets/SVG/ArrowForwardSmallG.svg'

const styles = {
    heading: {
      flex: 0,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    buttons: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      ...Metrics.topPadding,
      ...Metrics.bottomPadding,
    },
    rows: {
      ...Metrics.horizontalPadding,
    },
    lightRow: {
        borderBottomWidth:1,
        borderColor: Colors.light,
      },
}

const yAxisLimit = 5
const portraitAxisLimit = 7
const landscapeAxisLimit = 10
const ticks = Array.from(Array(yAxisLimit), (value,index) => index)

const Graph = ({ children }) => (
    <View>
        {Children.map(children, (child, i) => {
            return <View key={i}>{child}</View>
        })}
    </View>
)
const HorizontalGrid = ({ axisWidth, fullWidth, height,yAxisEnabledCount,horizontalContentInset, empty, ...rest }) => {
    if(empty) yAxisEnabledCount = 0
    const apx = (size = 0) => {
        return (fullWidth / 750) * size;
      };
    // const horizontalContentInset = { left: apx(0), right: apx(40) }; 
    let width = apx(750 - (yAxisEnabledCount*axisWidth))-horizontalContentInset.right-horizontalContentInset.left+1
    return <></>
    // return(
    //     <g >
    //     {ticks.map((item) => (
    //         <line
    //             key={'horizLine' + item}
    //             x1={horizontalContentInset.left}
    //             y1={height/(yAxisLimit+1)*(item+1)}
    //             x2={width+horizontalContentInset.left}
    //             y2={height/(yAxisLimit+1)*(item+1)}
    //             stroke={Colors.light}
    //             strokeWidth="1"
    //         />))}
    //     </g>
    // )
}

const VerticalGrid = ({ xdata, yAxisEnabledCount, axisWidth, fullWidth, height, landscape,horizontalContentInset, ...rest }) => {
    if(xdata.length <=1) yAxisEnabledCount =0
    const apx = (size = 0) => {
        return (fullWidth / 750) * size;
      };
    // const horizontalContentInset = { left: apx(0), right: apx(40) }; 

    let axisLimit = 0
    let xAxis = []
    let size = xdata.length
    let first = Number(xdata[0])
    let last = Number(xdata[size-1])
    let diff = last - first //span of graph in seconds
    // first = new Date(first * 1000)
    // last = new Date(last * 1000)
    axisLimit = landscape? landscapeAxisLimit: portraitAxisLimit
    let axis = []
    let tempAxis = []
    let tickDiff =  diff/(axisLimit-1)
    let tickDiffRatio
    let tickDiffArray = []
    let tempTickDiffArray = []
    let offsetRatio
    let firstTick
    let firstDayStart = new Date(first*1000);
    firstDayStart.setHours(24,0,0,0);
    firstDayStart = firstDayStart.getTime()/1000
    let firstMonthStart = new Date(first*1000);
    firstMonthStart.setMonth(firstMonthStart.getMonth()+1,1)
    firstMonthStart.setHours(0,0,0,0);
    firstMonthStart = firstMonthStart.getTime()/1000
    if(diff<=60){//Min or less? Show specific time 
        offsetRatio = 0
        tickDiffRatio = tickDiff/diff
        for(let i=0;i<=axisLimit;i++){
            if((first+(tickDiff*i))<=last ) tempAxis.push(new Date((first+(tickDiff*i))*1000))
        }
        diff = 0
    } else if(diff<=60*60){//Hr or less? Show specific time 
        //Start at next minute
        firstTick = Math.ceil(first/60)*60
        tickDiff = Math.ceil(tickDiff/60)*60
        offsetRatio = (firstTick - first)/diff
        tickDiffRatio = tickDiff/diff
        for(let i=0;i<=axisLimit;i++){
            if((firstTick+(tickDiff*i))<=last ) tempAxis.push(new Date((firstTick+(tickDiff*i))*1000))
        }
        diff = 1
    } else if(diff<=60*60*24){//1day or less show hr
        //Start at next hour
        firstTick = Math.ceil(first/60/60)*60*60
        tickDiff = Math.ceil(tickDiff/60/60)*60*60
        offsetRatio = (firstTick - first)/diff
        tickDiffRatio = tickDiff/diff
        for(let i=0;i<=axisLimit;i++){
            if((firstTick+(tickDiff*i))<=last ) tempAxis.push(new Date((firstTick+(tickDiff*i))*1000))
        }
        diff = 2
    } else if(diff<=60*60*24*7){//1 week or less show day
        //Start at next day
        firstTick = firstDayStart
        tickDiff = 86400 //1 day
        offsetRatio = (firstTick - first)/diff
        tickDiffRatio = tickDiff/diff
        for(let i=0;i<=axisLimit;i++){
            if((firstTick+(tickDiff*i))<=last ) tempAxis.push(new Date((firstTick+(tickDiff*i))*1000))
        }
        diff = 3
    } else if(diff<=60*60*24*31){//1 month or less show date
        //Start at next day
        firstTick = firstDayStart
        let tickCalc = Math.round(tickDiff/86400) // How many days?
        if(tickCalc<1) tickCalc = 1
        tickDiff = 86400*tickCalc //x days
        offsetRatio = (firstTick - first)/diff
        tickDiffRatio = tickDiff/diff
        for(let i=0;i<=axisLimit;i++){
            if((firstTick+(tickDiff*i))<=last ) tempAxis.push(new Date((firstTick+(tickDiff*i))*1000))
        }
        diff = 4
    } else if(diff<=60*60*24*365){//1year or less show month
        //Start at next day
        firstTick = firstMonthStart
        let tickCalc = Math.round(tickDiff/86400) // How many days?
        if(tickCalc<1) tickCalc = 1
        tickDiff = 86400*tickCalc //x days
        offsetRatio = (firstTick - first)/diff
        tickDiffRatio = tickDiff/diff
        for(let i=0;i<=axisLimit;i++){
            if((firstTick+(tickDiff*i))<=last ) tempAxis.push(new Date((firstTick+(tickDiff*i))*1000))
        }
        diff = 5
    } else{//>1year show year
        firstTick = firstMonthStart
        let tickCalc = Math.round(tickDiff/86400/31) // How many months?
        if(tickCalc<1) tickCalc = 1
        tickDiff = 86400*31*tickCalc //x months
        offsetRatio = (firstTick - first)/diff
        let prevDate
        for(let i=0;i<=axisLimit;i++){
            let tempDate = new Date((firstTick+(tickDiff*i))*1000)
            let month = tempDate.getMonth()
            tempDate.setMonth(month,1)
            tempDate.setHours(0,0,0,0);
            if(tempDate/1000<=last ){
                tempAxis.push(tempDate)
                if(_.isEmpty(tempTickDiffArray)){
                    tempTickDiffArray.push(0)
                    prevDate = tempDate
                }else{
                    tempTickDiffArray.push((tempDate-prevDate)/1000/diff)
                    prevDate = tempDate
                }
            } 
        }
        diff = 6
    } 
    for(let i=0;i<tempAxis.length;i++){
        if(tempAxis.indexOf(tempAxis[i]) != i){
            // Don't add
        }else{
            axis.push(tempAxis[i])
            if(!_.isEmpty(tempTickDiffArray)) tickDiffArray.push(tempTickDiffArray[i])
        }
    }
    xAxis = axis
    if(isNaN(offsetRatio)) offsetRatio = 1
    if(isNaN(tickDiffRatio)) tickDiffRatio = 1
    let width = apx(750 - (yAxisEnabledCount*axisWidth))-horizontalContentInset.right-horizontalContentInset.left+1
    return <></>
    // return( 
    // // <svg width={width = apx(750 - (yAxisEnabledCount*axisWidth))-horizontalContentInset.right+1} height="100%" >
    //     <g >
    //     {/* top axis */}
    //     <line
    //         x1={horizontalContentInset.left}
    //         y1={0}
    //         x2={width+horizontalContentInset.left}
    //         y2={0}
    //         stroke={Colors.light}
    //         strokeWidth="1"
    //     />
    //     <line
    //         x1={horizontalContentInset.left}
    //         y1={height-1}
    //         x2={width+horizontalContentInset.left}
    //         y2={height-1}
    //         stroke={Colors.light}
    //         strokeWidth="1"
    //     />
    //     <line
    //           x1={horizontalContentInset.left}
    //           y1={0}
    //           x2={horizontalContentInset.left}
    //           y2={height}
    //           stroke={Colors.light}
    //           strokeWidth="1"
    //         />
    //       {!_.isEmpty(xAxis)?xAxis.map((item,index) => {
    //           let tempX
    //           if(_.isEmpty(tickDiffArray)){
    //             tempX = ((width-apx(1))*tickDiffRatio*index )+(offsetRatio*(width-apx(1)))+horizontalContentInset.left
    //           }else{
    //             let tickOffset = tickDiffArray.reduce(
    //                 (prev, curr, i) => {
    //                     if(i<=index){
    //                     return prev + curr
    //                     }else{
    //                     return prev
    //                     }
    //                 },0);
    //             tempX = ((width-apx(1))*tickOffset )+(offsetRatio*(width-apx(1)))+horizontalContentInset.left
    //           }
    //           return (
    //             item != ""?(<line
    //               key={'vertLine' + index}
    //               x1={tempX}
    //               y1={0}
    //               x2={tempX}
    //               y2={height}
    //               stroke={Colors.light}
    //               strokeWidth="1"
    //             />):<></>
    //           )
    //         }):
    //       <></>}
    //       {_.isEmpty(xdata) || xdata.length == 1?
    //       <g > 
    //         <line
    //             x1={(width+horizontalContentInset.left)/5*1+horizontalContentInset.left}
    //             y1={0}
    //             x2={(width+horizontalContentInset.left)/5*1+horizontalContentInset.left}
    //             y2={height}
    //             stroke={Colors.light}
    //             strokeWidth="1"
    //         />
    //         <line
    //             x1={(width+horizontalContentInset.left)/5*2+horizontalContentInset.left}
    //             y1={0}
    //             x2={(width+horizontalContentInset.left)/5*2+horizontalContentInset.left}
    //             y2={height}
    //             stroke={Colors.light}
    //             strokeWidth="1"
    //         />
    //         <line
    //             x1={(width+horizontalContentInset.left)/5*3+horizontalContentInset.left}
    //             y1={0}
    //             x2={(width+horizontalContentInset.left)/5*3+horizontalContentInset.left}
    //             y2={height}
    //             stroke={Colors.light}
    //             strokeWidth="1"
    //         />
    //         <line
    //             x1={(width+horizontalContentInset.left)/5*4+horizontalContentInset.left}
    //             y1={0}
    //             x2={(width+horizontalContentInset.left)/5*4+horizontalContentInset.left}
    //             y2={height}
    //             stroke={Colors.light}
    //             strokeWidth="1"
    //         />
    //         <text
    //           key={'graphEmpty'}
    //           fontSize={Fonts.medium.fontSize}
    //           fontFamily='TitilliumWeb-Regular'
    //           x={(width+horizontalContentInset.left)/2+horizontalContentInset.left}
    //           y={height/2}
    //           fill = {Colors.lightGrey}
    //           textAnchor="middle">{_.isEmpty(xdata)?'No Graph Data Available For This Scope':'Not Enough Data to Graph'}</text>
    //       </g>:<></>}
          
    //     <line
    //         x1={width+horizontalContentInset.left}
    //         y1={0}
    //         x2={width+horizontalContentInset.left}
    //         y2={height}
    //         stroke={Colors.light}
    //         strokeWidth="1"
    //       />
    //     </g>
    // // </svg>
    // )   
    }
Graph.YAxis = ({ style,axis,maxData,minData, toolType,index, attributes,isLoading,height, ...rest }) => {
    if(maxData == undefined || minData == undefined) return <></>//return(<svg width={width = style.width} height={height}></svg>)
    let TOOL_CH_ENUM = []
    switch (toolType) {
        case ToolTypes.THP:
            TOOL_CH_ENUM= THP_CH_ENUM
          break;
        case ToolTypes.SDP:
            TOOL_CH_ENUM= SDP1_CH_ENUM
          break;
        case ToolTypes.ANALOG_4_CH:
            TOOL_CH_ENUM= SA4C_CH_ENUM
          break;
        case ToolTypes.THERMO_4_CH:
            TOOL_CH_ENUM= ST4C_CH_ENUM
          break;
        case ToolTypes.SWIM:
            TOOL_CH_ENUM= SSS1_CH_ENUM
          break;
        case ToolTypes.CHEM:
            TOOL_CH_ENUM= SCP1_CH_ENUM
          break;
        default:
          break;
    }
    console.log('YAxis toolType:',toolType)
    console.log('YAxis minData:',minData)
    console.log('YAxis maxData:',maxData)
    console.log('YAxis axis:',axis)
    console.log('YAxis attributes:',attributes)
    console.log('YAxis TOOL_CH_ENUM:',TOOL_CH_ENUM)
    let min=axis.auto?Math.min(...axis.channels.reduce((prev,cur)=>prev.concat(minData[_.findIndex(attributes,function(o) { return o == TOOL_CH_ENUM[cur]})]),[])):axis.min
    let max=axis.auto?Math.max(...axis.channels.reduce((prev,cur)=>prev.concat(maxData[_.findIndex(attributes,function(o) { return o == TOOL_CH_ENUM[cur]})]),[])):axis.max
    let tickDiff = (max-min)/(ticks.length+1)
    console.log('TICKS:', ticks)
    console.log('YAxis min:',min)
    console.log('YAxis max:',max)
    if(isLoading){
        return <></>
        // return <svg width={width = style.width} height={height}></svg>
    }else{
        return(
            <View height={height} style={{justifyContent:'space-between',display:'flex',...Helpers.column,width:50}}>
            {/* <svg  preserveAspectRatio="xMidYMix meet" width={width = style.width} height={height}> */}
                {/* <g preserveAspectRatio="xMidYMix meet" x={width/2}> */}
                    <View 
                    style={{
                        display:'flex',
                        // backgroundColor:'green',
                        height: ((height)/(yAxisLimit+2)) ,
                        justifyContent:'center',
                        alignItems:'center',}}>
                    <Text 
                        style={{...Helpers.textCenter,color:style.backgroundColor,paddingLeft:Spacing.sm,paddingRight:Spacing.sm}}
                        as={"small"}
                        weight={'bold'}
                        >{max==null?"":max.toFixed(2).length > 5?max.toFixed(0):max.toFixed(2).length > 4?max.toFixed(1):max.toFixed(2)}
                    </Text>
                    </View>
                    {/* <text
                        key={'yLabel-1'}
                        preserveAspectRatio="xMidYMix meet"
                        fontSize={Fonts.small.fontSize}
                        fontFamily='TitilliumWeb-Bold'
                        x={0}
                        y={14}
                        fill = {style.backgroundColor}
                        textAnchor="middle">{max==null?"":max.toFixed(2).length > 5?max.toFixed(0):max.toFixed(2).length > 4?max.toFixed(1):max.toFixed(2)}
                    </text> */}
                  {ticks.map((item) => (
                    <View 
                    style={{
                        display:'flex',
                        height: ((height)/(yAxisLimit+2)),
                        justifyContent:'center',
                        alignItems:'center',}}>
                    <Text 
                        style={{...Helpers.textCenter,color:style.backgroundColor,paddingLeft:Spacing.sm,paddingRight:Spacing.sm}}
                        as={"small"}
                        weight={'bold'}
                        >{max==null?"":(max-(tickDiff*(item+1))).toFixed(2).length > 5?(max-(tickDiff*(item+1))).toFixed(0):(max-(tickDiff*(item+1))).toFixed(2).length > 4?(max-(tickDiff*(item+1))).toFixed(1):(max-(tickDiff*(item+1))).toFixed(2)}
                    </Text>
                    </View>
                    // <text
                    //     key={'yLabel' + item}
                    //     preserveAspectRatio="xMidYMix meet"
                    //     fontSize={Fonts.small.fontSize}
                    //     fontFamily='TitilliumWeb-Bold'
                    //     x={0}
                    //     y={(height)/(yAxisLimit+1)*(item+1)+14}
                    //     fill = {style.backgroundColor}
                    //     textAnchor="middle">{max==null?"":(max-(tickDiff*(item+1))).toFixed(2).length > 5?(max-(tickDiff*(item+1))).toFixed(0):(max-(tickDiff*(item+1))).toFixed(2).length > 4?(max-(tickDiff*(item+1))).toFixed(1):(max-(tickDiff*(item+1))).toFixed(2)}</text>               
                  ))}
                    {/* <text
                        key={'yLabelLast'}
                        preserveAspectRatio="xMidYMix meet"
                        fontSize={Fonts.small.fontSize}
                        fontFamily='TitilliumWeb-Bold'
                        x={0}
                        y={height+12}
                        fill = {style.backgroundColor}
                        textAnchor="middle">{min==null?"":min.toFixed(2).length > 5?min.toFixed(0):min.toFixed(2).length > 4?min.toFixed(1):min.toFixed(2)}
                    </text> */}
                    <View 
                    style={{
                        display:'flex',
                        // backgroundColor:'orange',
                        height: ((height)/(yAxisLimit+2)),
                        // marginBottom:2,
                        justifyContent:'center',
                        alignItems:'center',}}>
                    <Text 
                        style={{...Helpers.textCenter,color:style.backgroundColor,paddingLeft:Spacing.sm,paddingRight:Spacing.sm}}
                        as={"small"}
                        weight={'bold'}
                        >{min==null?"":min.toFixed(2).length > 5?min.toFixed(0):min.toFixed(2).length > 4?min.toFixed(1):min.toFixed(2)}
                    </Text>
                    </View>
                {/* </g> */}
            {/* </svg> */}
            </View>)
    }
    
}

Graph.XAxis = ({ xdata, yAxisEnabledCount,axisWidth,width,landscape,horizontalContentInset, isLoading,verticalLines, setVerticalLines,...rest }) => {
    // const apx = (size = 0) => {
    //     return (width / 750) * size;
    // };
    const timeFormat = '12H'//useSelector((state) =>getTimeFormat(state))  

    let axisLimit = 0
    let xAxis = []
    let size = xdata.length
    let first = Number(xdata[0])
    let last = Number(xdata[size-1])
    let diff = last - first //span of graph in seconds
    // first = new Date(first * 1000)
    // last = new Date(last * 1000)
    axisLimit = landscape? landscapeAxisLimit: portraitAxisLimit
    let axis = []
    let tempAxisLabels = []
    let tempAxis = []
    let tickDiff =  diff/(axisLimit-1)
    let tickDiffRatio
    let tickDiffArray = []
    let tempTickDiffArray = []
    let offsetRatio
    let firstTick
    let firstDayStart = new Date(first*1000);
    firstDayStart.setHours(24,0,0,0);
    firstDayStart = firstDayStart.getTime()/1000
    let firstMonthStart = new Date(first*1000);
    firstMonthStart.setMonth(firstMonthStart.getMonth()+1,1)
    firstMonthStart.setHours(0,0,0,0);
    firstMonthStart = firstMonthStart.getTime()/1000
    if(diff<=60){//Min or less? Show specific time 
        offsetRatio = 0
        tickDiffRatio = tickDiff/diff
        for(let i=0;i<=axisLimit;i++){
            if((first+(tickDiff*i))<=last ) tempAxis.push(new Date((first+(tickDiff*i))*1000))
        }
        diff = 0
    } else if(diff<=60*60){//Hr or less? Show specific time 
        //Start at next minute
        firstTick = Math.ceil(first/60)*60
        tickDiff = Math.ceil(tickDiff/60)*60
        offsetRatio = (firstTick - first)/diff
        tickDiffRatio = tickDiff/diff
        for(let i=0;i<=axisLimit;i++){
            if((firstTick+(tickDiff*i))<=last ) tempAxis.push(new Date((firstTick+(tickDiff*i))*1000))
        }
        diff = 1
    } else if(diff<=60*60*24){//1day or less show hr
        //Start at next hour
        firstTick = Math.ceil(first/60/60)*60*60
        tickDiff = Math.ceil(tickDiff/60/60)*60*60
        offsetRatio = (firstTick - first)/diff
        tickDiffRatio = tickDiff/diff
        for(let i=0;i<=axisLimit;i++){
            if((firstTick+(tickDiff*i))<=last ) tempAxis.push(new Date((firstTick+(tickDiff*i))*1000))
        }
        diff = 2
    } else if(diff<=60*60*24*7){//1 week or less show day
        //Start at next day
        firstTick = firstDayStart
        tickDiff = 86400 //1 day
        offsetRatio = (firstTick - first)/diff
        tickDiffRatio = tickDiff/diff
        for(let i=0;i<=axisLimit;i++){
            if((firstTick+(tickDiff*i))<=last ) tempAxis.push(new Date((firstTick+(tickDiff*i))*1000))
        }
        diff = 3
    } else if(diff<=60*60*24*31){//1 month or less show date
        //Start at next day
        firstTick = firstDayStart
        let tickCalc = Math.round(tickDiff/86400) // How many days?
        if(tickCalc<1) tickCalc = 1
        tickDiff = 86400*tickCalc //x days
        offsetRatio = (firstTick - first)/diff
        tickDiffRatio = tickDiff/diff
        for(let i=0;i<=axisLimit;i++){
            if((firstTick+(tickDiff*i))<=last ) tempAxis.push(new Date((firstTick+(tickDiff*i))*1000))
        }
        diff = 4
    } else if(diff<=60*60*24*365){//1year or less show month
        firstTick = firstMonthStart
        let tickCalc = Math.round(tickDiff/86400) // How many days?
        if(tickCalc<1) tickCalc = 1
        tickDiff = 86400*tickCalc //x days
        offsetRatio = (firstTick - first)/diff
        tickDiffRatio = tickDiff/diff
        for(let i=0;i<=axisLimit;i++){
            if((firstTick+(tickDiff*i))<=last ) tempAxis.push(new Date((firstTick+(tickDiff*i))*1000))
        }
        diff = 5
    } else{//>1year show year
        firstTick = firstMonthStart
        let tickCalc = Math.round(tickDiff/86400/31) // How many months?
        if(tickCalc<1) tickCalc = 1
        tickDiff = 86400*31*tickCalc //x months
        offsetRatio = (firstTick - first)/diff
        let prevDate
        for(let i=0;i<=axisLimit;i++){
            let tempDate = new Date((firstTick+(tickDiff*i))*1000)
            let month = tempDate.getMonth()
            tempDate.setMonth(month,1)
            tempDate.setHours(0,0,0,0);
            if(tempDate/1000<=last ){
                tempAxis.push(tempDate)
                if(_.isEmpty(tempTickDiffArray)){
                    tempTickDiffArray.push(0)
                    prevDate = tempDate
                }else{
                    tempTickDiffArray.push((tempDate-prevDate)/1000/diff)
                    prevDate = tempDate
                }
            } 
        }
        diff = 6
    } 
    tempAxisLabels = []
    for(let i=0;i<tempAxis.length;i++){
        switch (diff) {
        case 0:
            tempAxisLabels[i] = HelperService.formatTime(tempAxis[i],1,true)
            break;
        case 1:
            tempAxisLabels[i] = HelperService.formatTime(tempAxis[i],0,true)
            break;
        case 2:
            tempAxisLabels[i] = HelperService.formatTime(tempAxis[i],2,true)
            break;
        case 3:
            tempAxisLabels[i] = days[tempAxis[i].getDay()]
            break;
        case 4:
            tempAxisLabels[i] = HelperService.formatDate(tempAxis[i],1,true)
            break;
        case 5:
            tempAxisLabels[i] = months[tempAxis[i].getMonth()]
            break;
        case 6:
            tempAxisLabels[i] = HelperService.formatDate(tempAxis[i],2,true)
            break;
        default:
            console.error("SHOULDN'T SEE THIS ERROR updateXAxis")
            break;
        }
        if(tempAxisLabels.indexOf(tempAxisLabels[i]) != i){
            // Don't add
            tempAxis[i] = null
            axis.push('')
            if(!_.isEmpty(tempTickDiffArray)) tickDiffArray.push(tempTickDiffArray[i])
        }else{
            axis.push(tempAxisLabels[i])
            if(!_.isEmpty(tempTickDiffArray)) tickDiffArray.push(tempTickDiffArray[i])
        }
    }
    if(!_.isEqual(tempAxis,verticalLines)){
        console.log('Temp Axis:',tempAxis)
        console.log('verticalLines:',verticalLines)
        tempAxis.push(new Date(last*1000))
        tempAxis.push(new Date(first*1000))
        verticalLines = tempAxis
        setVerticalLines(tempAxis)
    } 
    xAxis = axis
    if(isNaN(offsetRatio)) offsetRatio = 1
    if(isNaN(tickDiffRatio)) tickDiffRatio = 1
    console.log('X AXIS:',xAxis)
    // return <></>
    return( 
    <svg width={width = width-horizontalContentInset.right} height={20}>
        <g y={0} x={0}>
          {/* {!_.isEmpty(xAxis)?xAxis.map((item,index) => (
            item != ""?(<line
              key={'item' + index}
              x1={((width-apx(1))*tickDiffRatio*index )+(offsetRatio*(width-apx(1)))}
              y1={0}
              x2={((width-apx(1))*tickDiffRatio*index )+(offsetRatio*(width-apx(1)))}
              y2={8}
              stroke={'black'}
              strokeWidth="1"
            />):<></>
          )):
          <></>} */}
          {!_.isEmpty(xAxis) && !isLoading?xAxis.map((item,index) => {
              let tempX
              if(_.isEmpty(tickDiffArray)){
                tempX = ((width)*tickDiffRatio*index )+(offsetRatio*(width))+horizontalContentInset.left
              }else{
                let tickOffset = tickDiffArray.reduce(
                    (prev, curr, i) => {
                      if(i<=index){
                        return prev + curr
                      }else{
                        return prev
                      }
                    },0);
                tempX = ((width)*tickOffset )+(offsetRatio*(width))+horizontalContentInset.left
              }
              return(
                <text
                key={'label ' + index}
                fontSize={diff == 0 && timeFormat == '12H'?Fonts.tiny.fontSize:Fonts.small.fontSize}
                fontFamily='TitilliumWeb-Regular'
                x={tempX}
                y={12}
                fill = {Colors.lightGrey}
                textAnchor="middle">{index>0 || ((tempX-(item.length/2))>10)?item:''}</text>
            )}):
          <></>}
          {/* <rect
            width={width}
            height="10"
            fill="rgb(0,0,255)"
            strokeWidth="3"
            stroke="rgb(0,0,0)"
        /> */}
          {/* {!_.isEmpty(xAxis)?xAxis.map((item,index) => (
            <text
              key={'label ' + index}
              fontSize={8}
              fontFamily='TitilliumWeb-Regular'
              x={((width-apx(1))*tickDiffRatio*index )+(offsetRatio*(width-apx(1)))+2}
              y={8}
              fill = "black"
              textAnchor="start">{item}</text>
          )):
          <></>} */}
        </g>
    </svg>
    )   
    }

    Graph.AxisUsed = ( dataLength, axis, enabled ) => {
    if(_.has(axis,'channels')){
        if(axis.channels.length==1){
            if(axis.enabled && enabled[axis.channels[0]] && dataLength > 1){
                return true
            }
        }else if(axis.channels.length>1){
            if(axis.enabled && dataLength > 1){
                return axis.channels.some((channel)=>enabled[channel])
            }
        }
    }
        return false  
    }

Graph.Graph = ({ xdata, data, dataRaw, enabled, yAxisEnabledCount, isLoading, multiGraph,positionX,positionY,
    panResponder,graphHeight,axisWidth,time,width,height,pinchZoomResponder,zoom, units, horizontalContentInset, preview, ...rest }) => {
    console.log("DATA Length:",xdata.length)
    if(xdata.length <= 1) yAxisEnabledCount = 0
    let fullWidth = width
    if(!multiGraph) enabled[0] = true //No need to send enabled 1 handlers for single graph
    let enabledCount = 0
    enabled.forEach(attribute => {
        if(attribute)  enabledCount++
      })
    const size  = xdata.length
    // if(size>0){
    //     data.forEach(attribute => {
    //         attribute = attribute.filter((item) => item.y != null && item.y != undefined)
    //     })
    //     dataRaw.forEach(attribute => {
    //         attribute = attribute.filter((item) => item.y != null && item.y != undefined)
    //     })
    // }
    

    const apx = (size = 0) => {
        return (width / 750) * size;
    };
    const apy = (size = 0) => {
        return (height / 750) * size;
    };
    let currentX = horizontalContentInset.left
    let currentY = apx(750)-horizontalContentInset.right
    const verticalContentInset = { top: apx(4), bottom: apx(4) };  
    // const horizontalContentInset = { left: apx(0), right: apx(40) }; 
    let graphData = enabled.map((attribute,index) => (
        {
            data: data[index],
            svg:{ stroke: attribute?colors[index]:Colors.transparent,strokeWidth:width>height?apy(2):apx(2) },
            animate:true
        }));


    const closestY = (x,y,yFunc,en,value) =>{
        //NOW ONLY CHECKING IF ALL VALUES ARE NULL
        const array = [];
        let allNull = true
        en.forEach((channel,index) => {
            if(channel && _.has(data[index][x],"y")) array.push([data[index][x].y,index+1])
        })
        array.forEach(data => {
            if (data[0] != null && (!isNaN(data[0]))) {
                allNull = false //found non null
            }
        })
        // const output = array.reduce((prev, curr) => {
        //     if(curr[0] != null){
        //         return Math.abs(yFunc(curr[0]) - y) < Math.abs(yFunc(prev[0]) - y) ? curr : prev
        //     }
        //     return prev
            
        // });
        if(value){
            if(allNull) return true //null
            return false//yFunc(output[0])
        }else{
            return false//output[1]
        }
    }

    const Tooltip = ({ x, y }) => {
        let counted = 0
        const countedIncrement = (enabled) =>{
            if(enabled) counted ++
        }
        if (positionX < 0) {
            return null;
        }

        let date = new Date(xdata[positionX]*1000)
        
        let longestData = 0
        let currentData = ""
        enabled.forEach((attribute, index) => {
            if(_.has(dataRaw[index][positionX],"y") && dataRaw[index][positionX].y !=null && !isNaN(dataRaw[index][positionX].y)){
                currentData = dataRaw[index][positionX].y.toFixed(2)+" "+units[index]
                if(currentData.length>longestData) longestData = currentData.length
            }
        })
        let dateString = HelperService.formatDate(date,1) + " " + HelperService.formatTime(date,0)
        let timeLength = (14*(HelperService.formatTime(date,0).length + 1))
        let toolTipWidth = Math.max(170,Math.floor(14*longestData),Math.floor((14*dateString.length)))
        let last = x(xdata[xdata.length-1])
        return <></>
            // return (
            //     <g x={x(xdata[positionX])} key="tooltip">
            //         {closestY(positionX,positionY,y,enabled,true) !=true?// != null Are all lines null at this point?
            //         <g
            //             x={x(xdata[positionX]) >= last/2 && width<height? -apx(toolTipWidth+1) :x(xdata[positionX]) >= last/2 && width>height? -apy(toolTipWidth+1):width<height?apx(1):apy(1)}
            //             y = {apx(40)}
            //         >
            //             <rect
            //                 y={width>height?(-apy(24 + 24 + 20) / 2):(-apx(24 + 24 + 20) / 2)}
            //                 rx={width>height?apy(12):apx(12)} // borderRadius
            //                 ry={width>height?apy(12):apx(12)} // borderRadius
            //                 width={width>height?apy(toolTipWidth):apx(toolTipWidth)}
            //                 height={width>height?apy(24+(enabledCount*24)+48):apx(24+(enabledCount*24)+48)}
            //                 stroke={Colors.light}//color
            //                 fill={Colors.light}//color
            //             />
            //             <text x={width>height?apy(toolTipWidth-timeLength):apx(toolTipWidth-timeLength)} textAnchor='end' fill={Colors.lightGrey} y={apx(0)} fontSize={Fonts.hint.fontSize} fontFamily='TitilliumWeb-Regular'>
            //                 {HelperService.formatDate(date,1)}
            //             </text>
            //             <text x={width>height?apy(toolTipWidth-15):apx(toolTipWidth-15)} textAnchor='end' fill={Colors.lightGrey} y={apx(0)} fontSize={Fonts.hint.fontSize} fontFamily='TitilliumWeb-Bold'>
            //                 {HelperService.formatTime(date,0)}
            //             </text>
            //             <line
            //                 x1={apx(0)}
            //                 x2={width>height?apy(toolTipWidth):apx(toolTipWidth)}//Number(ticks.length)
            //                 y={width>height?apy(18):apx(18)}
            //                 stroke={Colors.white}
            //                 strokeWidth={width>height?apy(2):apx(2)}
            //                 // strokeDasharray={[6, 3]}
            //             />
            //             {enabled.map((attribute, index) => (
            //                 attribute? <><text
            //                     x={width>height?apy(toolTipWidth-15):apx(toolTipWidth-15)}
            //                     y={width>height?apy(48 + (24*counted)):apx(48 + (24*counted))}
            //                     fontSize={Fonts.hint.fontSize}
            //                     // fontSize={width>height?apy(24):apx(24)}
            //                     // fontWeight="bold"
            //                     fill={colors[index]}
            //                     textAnchor='end'
            //                     fontFamily='TitilliumWeb-Regular'>
            //                     {_.has(dataRaw[index][positionX],"y") && dataRaw[index][positionX].y !=null && !isNaN(dataRaw[index][positionX].y)?dataRaw[index][positionX].y.toFixed(2)+" "+units[index]:"null"}
            //                 </text>
            //                 {countedIncrement(attribute)}
            //                 </>:<></>                            
            //             ))}
            //         </g>:<></>} 
                    
        
            //         <g x={x}>
            //             <line
            //                 y1={width>height?apy(2):apx(2)}
            //                 y2={graphHeight-1}//Number(ticks.length)
            //                 stroke={Colors.lightGrey}
            //                 strokeWidth={width>height?apy(2):apx(2)}
            //                 strokeDasharray={[6, 3]}
            //             />
            //             {/* {closestY(positionX,positionY,y,enabled1,enabled2,enabled3,enabled4,enabled5,true)!=null?
            //             <circle
            //                 cy={closestY(positionX,positionY,y,enabled1,enabled2,enabled3,enabled4,enabled5,true) }
            //                 // cy={positionY}
            //                 r={apx(20 / 2)}
            //                 stroke="#fff"
            //                 strokeWidth={apx(2)}
            //                 fill="#000000"
            //             />:<></>} */}
            //             {dataRaw.map((raw, index) => (
            //                 _.has(raw[positionX],"y") && enabled[index] && raw[positionX].y !=null && !isNaN(raw[positionX].y)?<circle
            //                     cy={y(data[index][positionX].y)}
            //                     r={width>height?apy(4):apx(4)}
            //                     stroke={Colors.light}
            //                     strokeWidth={width>height?apy(1):apx(1)}
            //                     fill={Colors.darkGrey}
            //                 />:<></>                          
            //             ))}      
            //         </g>
            //     </g>
            // )
    };

    const SliderLines = ({ x, y }) => {
        currentX = positionX>=0?x(xdata[positionX]):positionX
        currentY = positionY>=0?x(xdata[positionY]):positionY
        return <></>
        // return (
        //     <g>
        //         <g x={x=currentX} key="sliderLine1"> 
        //             {currentX>=0?
        //                 <line
        //                     y1={width>height?apy(2):apx(2)}
        //                     y2={graphHeight-1}//Number(ticks.length)
        //                     stroke={Colors.lightGrey}
        //                     strokeWidth={width>height?apy(2):apx(2)}
        //                     strokeDasharray={[6, 3]}
        //                 />:<></>}
                    
        //         </g>
        //         <g x={currentY} key="sliderLine2"> 
        //             {currentY>=0?
        //                 <line
        //                     y1={width>height?apy(2):apx(2)}
        //                     y2={graphHeight-1}//Number(ticks.length)
        //                     stroke={Colors.lightGrey}
        //                     strokeWidth={width>height?apy(2):apx(2)}
        //                     strokeDasharray={[6, 3]}
        //                 />:<></>}
        //         </g>
        //     </g> 
        // )
    };
    const Sliders = ({landscape}) => {
        return <></>
        // return (
        //     <svg width={width = apx(750)} height={landscape?apx(25):apy(25)}>
        //         <g>
        //             <g x={currentX-10} key="slider1"> 
        //                 {currentX>=0?
        //                 <g y={-1}>
        //                     <Icon svg={sliderIcon} size="s20" aspect={1} />
        //                 </g>:<></>}
        //                 {currentX==-1?
        //                 <g y={2}  x={horizontalContentInset.left+6}>
        //                     <Icon svg={leftIcon} size="s20" aspect={1} />
        //                 </g>:<></>}
        //                 {currentX==-2?
        //                 <g y={2}  x={apx(750)-horizontalContentInset.right-2}>
        //                     <Icon svg={rightIcon} size="s20" aspect={1} />
        //                 </g>:<></>}
                        
                        
        //             </g>
        //             <g x={currentY-10} key="slider2"> 
                        
        //                 {currentY>=0?
        //                 <g y={-1}>
        //                     <Icon svg={sliderIcon} size="s20" aspect={1} />
        //                 </g>:<></>}
        //                 {currentY==-1?
        //                 <g y={2}  x={horizontalContentInset.left+6}>
        //                     <Icon svg={leftIcon} size="s20" aspect={1} />
        //                 </g>:<></>}
        //                 {currentY==-2?
        //                 <g y={2}  x={apx(750)-horizontalContentInset.right-2}>
        //                     <Icon svg={rightIcon} size="s20" aspect={1} />
        //                 </g>:<></>}                    
        //             </g>
        //         </g> 
        //     </svg>
        // )
    };

    
    if(isLoading){
        console.log("LOADING GRAPH")
        return <View style={{ 
            height:preview?graphHeight+22:graphHeight, 
            width: apx(750 - (2*yAxisEnabledCount*axisWidth)),
            flexDirection: 'row',
            alignItems:'center',
            justifyContent: 'center'}}
        ><LoadingIcon /></View>
    }else{
        console.log("NOT LOADING", "Enabled count:", enabledCount,"DATA LEN:",size, "ZOOM",zoom)
            return (
                <View style={{ width: apx(750 - (yAxisEnabledCount*axisWidth))}}
                {...zoom?pinchZoomResponder.current.handlers:size>1?panResponder(xdata).current.panHandlers:<></>}
                >
                    <View style={{height:preview?graphHeight+22:graphHeight}}>
                    {/* <LineChart
                        style={{ height: graphHeight, width: apx(750 - (yAxisEnabledCount*axisWidth))}}
                        data={ graphData }
                        animate={true}
                        animationDuration={300}
                        yAccessor={({ item }) => item.y}
                        xAccessor={({ item }) => item.x}
                        yMin={0}
                        yMax={1}
                        // xScale={scale.scaleTime}
                        contentInset={{ ...verticalContentInset,...horizontalContentInset}}
                        // curve={shape.curveMonotoneX}
                    >   
                        <HorizontalGrid axisWidth={axisWidth} fullWidth={fullWidth} height={height} yAxisEnabledCount={yAxisEnabledCount} horizontalContentInset={horizontalContentInset} belowChart={true} empty={xdata.length==0}/>
                        <VerticalGrid xdata={xdata} yAxisEnabledCount={yAxisEnabledCount} axisWidth={axisWidth} fullWidth={fullWidth} height={height} landscape={width>height} horizontalContentInset={horizontalContentInset} belowChart={true}/>
                        {!preview?<Tooltip  />:<SliderLines/>}
                    </LineChart> */}
                    {/* <Sliders/> */}
                    {preview?<Sliders landscape={width>height}/>:<></>}        
                    </View>
                </View>
            )   
    }
       
}

Graph.LinearScaling = ({  index,graphHeight,width,ax,bx,ay,by,unit,rawUnit,...rest }) => {
    let maxY = Math.max(ay.length,by.length)
    let maxX = Math.max(ax.length,bx.length)
    let left = 150
    let right = 60
    if(maxY>4){
        left+=(maxY-4)*14
    }
    if(maxX>4){
        right+=(maxX-4)*14
    }
    const apx = (size = 0) => {
        return ((width-(2*Spacing.md)) / 750) * size;//
    };
    let axNum = Number(ax)
    let bxNum = Number(bx)
    let ayNum = Number(ay)
    let byNum = Number(by)
    const verticalContentInset = { top: apx(40), bottom: apx(80) };  
    const horizontalContentInset = { left: apx(left), right: apx(right) }; 
    let posSlope = [{"x":0,"y":0},{"x":1,"y":1}]
    let negSlope = [{"x":0,"y":1},{"x":1,"y":0}]
    let noSlope = [{"x":0,"y":0.5},{"x":1,"y":0.5}]
    let curSlope = (byNum>ayNum && bxNum>axNum) || (ayNum>byNum && axNum>bxNum) ?posSlope:(ayNum>byNum && bxNum>axNum) || (byNum>ayNum && axNum>bxNum)?negSlope:noSlope
    let graphData = [
        {
            data: curSlope,
            svg:{ stroke: colors[index],strokeWidth:apx(2) },
            animate:true
        }];
    
    const Points = ({ x, y }) => {
        return <></>
        // return (
        //     <g>
        //         <g x={x=horizontalContentInset.left}> 
        //             <circle
        //                 cy={curSlope == posSlope?(graphHeight-verticalContentInset.bottom):curSlope == negSlope?(verticalContentInset.top):((graphHeight-verticalContentInset.bottom-verticalContentInset.top)/2 + verticalContentInset.top)}
        //                 r={apx(4)}
        //                 stroke={colors[index]}
        //                 strokeWidth={apx(1)}
        //                 fill={colors[index]}
        //             />
        //         </g>
        //         <g x={x=apx(750)-horizontalContentInset.right}> 
        //             <circle
        //                 cy={curSlope == negSlope?(graphHeight-verticalContentInset.bottom):curSlope == posSlope?(verticalContentInset.top):((graphHeight-verticalContentInset.bottom-verticalContentInset.top)/2 + verticalContentInset.top)}
        //                 r={apx(4)}
        //                 stroke={colors[index]}
        //                 strokeWidth={apx(1)}
        //                 fill={colors[index]}
        //             />
        //         </g>
        //     </g> 
        // )
    };
    const Warning = ({ x, y }) => {
        return <></>
        // return (
        //     <g>
        //         <text
        //         fontSize={Fonts.medium.fontSize}
        //         fontFamily='TitilliumWeb-Regular'
        //         x={apx(750/2)}
        //         y={(graphHeight-verticalContentInset.bottom-verticalContentInset.top)/2 + verticalContentInset.top + 4}
        //         fill = {Colors.lightGrey}
        //         textAnchor="middle">{'Input values for A and B must be different'}</text>
        //     </g> 
        // )
    };
    
    const LinearGrid = ({ x, y }) => {
        return <></>
        // return (
        //     <g>
        //         <g x={x=horizontalContentInset.left}> 
        //             <line
        //                 y1={verticalContentInset.top}
        //                 y2={graphHeight-verticalContentInset.bottom}
        //                 stroke={Colors.vlightGrey}
        //                 strokeWidth={apx(2)}
        //             />
        //             <text 
        //                 textAnchor='middle' 
        //                 fill={Colors.lightGrey} 
        //                 y={curSlope == negSlope?(verticalContentInset.top-4):(graphHeight-verticalContentInset.bottom+14)} 
        //                 fontSize={Fonts.hint.fontSize} 
        //                 fontFamily='TitilliumWeb-Regular'>
        //                     {bxNum>axNum?"A":"B"}
        //             </text>
        //             <text 
        //                 textAnchor='middle' 
        //                 fill={Colors.lightGrey} 
        //                 y={graphHeight-12} 
        //                 fontSize={Fonts.hint.fontSize} 
        //                 fontFamily='TitilliumWeb-Regular'>
        //                     {(bxNum>axNum?(ax):(bx)) +" "+rawUnit}
        //             </text>
        //         </g>
        //         <g x={x=apx(750)-horizontalContentInset.right}> 
        //             <line
        //                 y1={verticalContentInset.top}
        //                 y2={graphHeight-verticalContentInset.bottom}
        //                 stroke={Colors.vlightGrey}
        //                 strokeWidth={apx(2)}
        //             />
        //             <text 
        //                 textAnchor='middle' 
        //                 fill={Colors.lightGrey} 
        //                 y={curSlope == posSlope?(verticalContentInset.top-4):(graphHeight-verticalContentInset.bottom+14)} 
        //                 fontSize={Fonts.hint.fontSize} 
        //                 fontFamily='TitilliumWeb-Regular'>
        //                     {bxNum>axNum?"B":"A"}
        //             </text>
        //             <text 
        //                 textAnchor='middle' 
        //                 fill={Colors.lightGrey} 
        //                 y={graphHeight-12} 
        //                 fontSize={Fonts.hint.fontSize} 
        //                 fontFamily='TitilliumWeb-Regular'>
        //                     {(bxNum>axNum?(bx):(ax)) +" "+rawUnit}
        //             </text>
        //         </g>
        //         <g> 
        //             <line
        //                 y1={verticalContentInset.top}
        //                 y2={verticalContentInset.top}
        //                 x1={horizontalContentInset.left}
        //                 x2={apx(750)-horizontalContentInset.right}
        //                 stroke={Colors.vlightGrey}
        //                 strokeWidth={apx(2)}
        //                 strokeDasharray={[6, 3]}
        //             />
        //             <line
        //                 y1={curSlope == negSlope?(graphHeight-verticalContentInset.bottom):curSlope == posSlope?(verticalContentInset.top):((graphHeight-verticalContentInset.bottom-verticalContentInset.top)/2 + verticalContentInset.top)}
        //                 y2={curSlope == negSlope?(graphHeight-verticalContentInset.bottom):curSlope == posSlope?(verticalContentInset.top):((graphHeight-verticalContentInset.bottom-verticalContentInset.top)/2 + verticalContentInset.top)}
        //                 x1={apx(750)-horizontalContentInset.right}
        //                 x2={apx(750)-horizontalContentInset.right + 10}
        //                 stroke={colors[index]}
        //                 strokeWidth={apx(2)}
        //             />
        //             <text 
        //                 textAnchor='end' 
        //                 fill={colors[index]} 
        //                 x={horizontalContentInset.left - 15}
        //                 y={4+(curSlope == negSlope?(graphHeight-verticalContentInset.bottom):curSlope == posSlope?(verticalContentInset.top):((graphHeight-verticalContentInset.bottom-verticalContentInset.top)/2 + verticalContentInset.top))} 
        //                 fontSize={Fonts.hint.fontSize} 
        //                 fontFamily='TitilliumWeb-Regular'>
        //                     {(bxNum>axNum?(by):(ay)) +" "+unit}
        //             </text>
        //             <line
        //                 y1={graphHeight-verticalContentInset.bottom}
        //                 y2={graphHeight-verticalContentInset.bottom}
        //                 x1={horizontalContentInset.left}
        //                 x2={apx(750)-horizontalContentInset.right}
        //                 stroke={Colors.vlightGrey}
        //                 strokeWidth={apx(2)}
        //                 strokeDasharray={[6, 3]}
        //             />
        //             <line
        //                 y1={curSlope == posSlope?(graphHeight-verticalContentInset.bottom):curSlope == negSlope?(verticalContentInset.top):((graphHeight-verticalContentInset.bottom-verticalContentInset.top)/2 + verticalContentInset.top)}
        //                 y2={curSlope == posSlope?(graphHeight-verticalContentInset.bottom):curSlope == negSlope?(verticalContentInset.top):((graphHeight-verticalContentInset.bottom-verticalContentInset.top)/2 + verticalContentInset.top)}
        //                 x1={horizontalContentInset.left - 10}
        //                 x2={horizontalContentInset.left}
        //                 stroke={colors[index]}
        //                 strokeWidth={apx(2)}
        //             />
        //             <text 
        //                 textAnchor='end' 
        //                 fill={colors[index]} 
        //                 x={horizontalContentInset.left - 15}
        //                 y={4+(curSlope == posSlope?(graphHeight-verticalContentInset.bottom):curSlope == negSlope?(verticalContentInset.top):((graphHeight-verticalContentInset.bottom-verticalContentInset.top)/2 + verticalContentInset.top))} 
        //                 fontSize={Fonts.hint.fontSize} 
        //                 fontFamily='TitilliumWeb-Regular'>
        //                     {(bxNum>axNum?(ay):(by)) +" "+unit}
        //             </text>
        //         </g>
        //     </g> 
        // )
    };

    return (
        <View style={{ width: width,alignSelf:'center',...styles.lightRow}} padding="md" sidePadding="md">
            <View style={{height:graphHeight}}>
            {/* <LineChart
                style={{ height: graphHeight, width: apx(750), backgroundColor:Colors.light, borderRadius: 5}}
                data={ axNum==bxNum?[{"x":0,"y":0}]:graphData }
                animate={true}
                animationDuration={300}
                yAccessor={({ item }) => item.y}
                xAccessor={({ item }) => item.x}
                yMin={0}
                yMax={1}
                contentInset={{ ...verticalContentInset,...horizontalContentInset}}
            >   
                {axNum==bxNum?<Warning />:<LinearGrid belowChart={true}/>}
                {axNum==bxNum?<></>:<Points />}
            </LineChart> */}
            </View>
        </View>
    )   
       
}
  
export default Graph
  